import language from '../../js/stores/language.js';
import carFeatures from '../../js/stores/car-feature.js';

const carFeatureLibrary = {
  async getLocalizedData (carId, languageSubKey) {
    let carFeatureList = [];
    const formData = {
      CarId: carId,
      LanguageCode: language.getters.Name.value,
      LanguageSubKey: languageSubKey,
    };

    let features = await carFeatures.dispatch('getFeaturesFromCarLocalized', formData);
    if (features.status !== undefined && features.status !== 200) {
      console.log(features.data.messages.error);
      return {};
    }

    let i = 0;
    for (var key in features) {
      let object = {
        "featureDetailId": features[i].CarFeatureDetailId,
        "name": features[i].CarFriendlyNameLocalized,
        "value": features[i].CarFeatureDetailValue,
        "type": features[i].CarFeatureType,
        "isUsed": features[i].CarFeatureDetailIsUsed,
        "iconImage": features[i].CarFeatureIconName,
        "iconType": features[i].CarFeatureIconType,
      }
      carFeatureList.push(object);
      i++;
    }

    return carFeatureList;
  }
};

export default carFeatureLibrary;
